//TODO: to check with Amit and remove unwanted code - sshrivastava
import { faCheckCircle, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon, Spin } from "antd";
import React from "react";
export var ProgressIcon = function () {
    return (React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading", spin: true, style: { fontSize: "1.25rem" } }) }));
};
export var SuccessIcon = function () {
    return React.createElement(Icon, { className: "color-green", style: { fontSize: "1.1rem" }, component: function () { return React.createElement(FontAwesomeIcon, { icon: faCheckCircle }); } });
};
export var FailureIcon = function () {
    return React.createElement(Icon, { className: "color-pink", style: { fontSize: "1.1rem" }, component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } });
};
export var ErrorLabel = function (_a) {
    var text = _a.text;
    return React.createElement(React.Fragment, null,
        React.createElement(Icon, { className: "fix-icon-top-1-px color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } }),
        React.createElement("span", { style: { paddingRight: "2px" } }),
        text);
};
//# sourceMappingURL=commons.js.map